<template>
  <div class="row text-center success-component">
    <div class="col-12">
      <div class="svg-banner-result svg-result-success">
        <svg-viewer
          class="ml-auto mr-auto"
          :src="require('../assets/images/banner/09/09-cross-success.svg')"
          height="130px"
          width="200px"
        >
        </svg-viewer>
      </div>
    </div>
    <div class="col-12 mb-2">
      <span class="success-title">Congratulazioni!</span>
    </div>
    <div class="col-12 mb-3">
      <span class="success-desc"
        >Simulazione inviata all’indirizzo <strong>{{ email }}</strong></span
      >
    </div>
    <div class="col-12 mb-5">
      <b-button variant="link red-link" @click="openPDF()"
        ><u>Scarica PDF</u></b-button
      >
    </div>
    <div class="col-12 mb-3">
      <b-button variant="white long" class="ml-auto mr-auto" @click="goHome()"
        >Torna alla Homepage</b-button
      >
    </div>
    <div class="col-6 mb-3" v-if="false">
      <b-button
        variant="primary long"
        class="float-left"
        @click="goToSimulation()"
        >Apri il preventivo</b-button
      >
    </div>
  </div>
</template>

<script>
import router from "../router";
import { resetState } from "../helpers/store.utils";
export default {
  name: "SavingSuccess",
  props: {
    email: String,
    pdf: String
  },
  data: () => {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    openPDF() {
      let pdf = this.pdf.replace('http:', 'https:');
      window.open(pdf, "_blank");
    },
    goHome() {
      resetState();
      router.push("/");
    },
    goToSimulation() {
      this.openPDF();
    }
  }
};
</script>

<style></style>
